import { render } from "./BenchmarksTable.vue?vue&type=template&id=23a6feb5&scoped=true"
import script from "./BenchmarksTable.vue?vue&type=script&lang=js"
export * from "./BenchmarksTable.vue?vue&type=script&lang=js"

import "./BenchmarksTable.vue?vue&type=style&index=0&id=23a6feb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a6feb5"]])

export default __exports__